export default __webpack_public_path__ + "static/6_24-a136cda9a2297fa88036dcce818d4958.png";